import classnames from 'classnames';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {setAppMode, toggleDisclaimer, toggleMenu} from './actions';
import './App.css';
import './components/Button.css';
import IntroSplash from './components/IntroSplash';
import PrintDisclaimer from './components/PrintDisclaimer';
import {MODES} from './Constants';
import AerologicalImagePanel from './containers/AerologicalImagePanel';
import BoundaryNavigator from './containers/BoundaryNavigator';
import Content from './containers/Content';
import IndicatorLegend from './containers/IndicatorLegend';
import IndicatorNavigator from './containers/IndicatorNavigator';
import Nav from './containers/Nav';

class App extends Component {

  doToggleMenu = (menuName) => {
    const { dispatch } = this.props;
    dispatch(toggleMenu(menuName));
  };

  doToggleDisclaimer = () => {
    const { dispatch } = this.props;
    dispatch(toggleDisclaimer());
  };

  doSetAppMode = (mode) => {
    const { dispatch } = this.props;
    dispatch(setAppMode(mode));
  };

  render() {
    const { active_menu, graphs_open, disclaimer_open, app_mode, aqfx_panel_open } = this.props;
    const cn = classnames('full-width',
      graphs_open ? 'graphs-open' : null,
      app_mode === MODES.WILDFIRE ? 'mode-wildfire' : null,
      app_mode === MODES.PLANNED_BURNS ? 'mode-burns' : null);
    return (
      <div className={cn}>
        <Nav>
          <div className="c-nav__buttons">
            <div className="nav__button boundary" onClick={() => this.doToggleMenu('boundaries')}/>
            <div className="nav__button legend" onClick={() => this.doToggleMenu('legend')}/>
            <div className="nav__button indicators" onClick={() => this.doToggleMenu('indicators')}/>
          </div>
          <div className={classnames('c-nav__item', 'boundary', { show: 'boundaries' === active_menu })}>
            <BoundaryNavigator/>
          </div>
          <IndicatorLegend/>
          <div className={classnames('c-nav__item', 'indicators', { show: 'indicators' === active_menu })}>
            <IndicatorNavigator/>
          </div>
        </Nav>
        <Content/>
        {disclaimer_open && <IntroSplash onClose={this.doToggleDisclaimer} setMode={this.doSetAppMode}/>}
        {aqfx_panel_open && <AerologicalImagePanel/>}
        <PrintDisclaimer/>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    active_menu: state.view.active_menu,
    graphs_open: state.view.graphs_open,
    disclaimer_open: state.view.disclaimer_open,
    app_mode: state.app.app_mode,
    aqfx_panel_open: state.aqfx.panel_open
  };
};

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js